import React, { Component } from 'react'
import BackButton from '../common/BackButton';
import Heading from '../common/Heading'
import getImage from '../images';
import styles from '../styles/loyalty.css';
import BenefitItem from './BenefitItem';
import ExclusiveBenefitItem from './ExclusiveBenefitItem';

export default class AllBenefitsPage extends Component {
    render() {
        const { pushPath, freebies, exclusiveFreebies } = this.props;
        return (
            <div style={{ padding: 25 }}>
                <div >
                    <BackButton onclick={() => { pushPath('/loyalty', null); }} />

                    <hr />
                </div>

                <div>
                    <Heading title="Showing" subTitle="Rewards Boutique" />
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                        {freebies.length > 0 ?
                            freebies.map((item, index) => {
                                return <div className={styles['fr-freebie-width']}>
                                    <BenefitItem item={item} key={index} onclick={() => pushPath('/freebie-details', { freebie: item, type: 'loyalty' })} />
                                </div>
                            })
                            :
                            <div className={styles['orderBox']}>
                                <h6>No Benefits available now.</h6>
                            </div>
                        }
                    </div>
                </div>
                <div>
                    <Heading title="Exclusive" subTitle="Benefits" />
                    <div style={{ display: 'flex', flexDirection: 'row', overflowX: 'scroll' }}>
                        {exclusiveFreebies.length > 0 ?
                            exclusiveFreebies.map((item, index) => {
                                return <ExclusiveBenefitItem item={item} key={index} onclick={() => pushPath('/freebie-details', { freebie: item, type: 'loyalty' })} />
                            })
                            :
                            <div className={styles['orderBox']}>
                                <h6>No Benefits available now.</h6>
                            </div>
                        }
                    </div>
                </div>
            </div>

        )
    }
}

